import {
  TripNumberBase,
  TripNumberCreatePayload,
  TripNumberFormValues,
  TripNumberUpdatePayload,
} from './type'

export function mapAPIDataToFormValues(data: TripNumberBase): TripNumberFormValues {
  return {
    id: data.trip_number_id,
    tripNumber: data.trip_number,
    tripNumberStatus: data.trip_number_status,
  }
}

export function mapFormDataToCreatePayload(data: TripNumberFormValues): TripNumberCreatePayload {
  return {
    trip_number: data.tripNumber,
    trip_number_status: data.tripNumberStatus,
  }
}

export function mapFormDataToUpdatePayload(data: TripNumberFormValues): TripNumberUpdatePayload {
  return {
    id: data.id!,
    trip_number: data.tripNumber,
    trip_number_status: data.tripNumberStatus,
  }
}
